<template>
  <div
    class="app-modal"
    :class="[showModal ? 'show' : 'hide']"
    @click="closeModal"
  >
    <div class="app-modal-wrap">
      <svgicon class="app-modal-close" icon="cancel"></svgicon>
      <div class="app-modal-inner" @click.stop>
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Progress",
  props: {
    show: Boolean
  },
  emits: {},

  computed: {
    showModal() {
      return this.show;
    }
  },
  methods: {
    closeModal(event) {
      this.$emit("onclosed", true);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/modules/progress.scss";
</style>



// WEBPACK FOOTER //
// src/components/resuables/progress.vue